import styled from "styled-components";

const LandingPageStyle = styled.div`
  background: #131314;
  min-height: 100vh;
  width: 100%;

  .login-component {
    background: #242429;
  }

  .login-modal {
    position: absolute;
    width: 554px;
    height: 622px;
    top: 50%;
    background: #242429;
    left: 50%;
    z-index: 5;
    border-radius: 20px;
    border: 1px solid white;
    transform: translate(-50%, 50%);
    padding: 32px 24px 24px 24px;
  }

  .login-heading-container {
    display: flex;
    justify-content: space-between;
  }

  .login-heading {
    font-family: Poppins;
    font-size: 27px;
    font-weight: 600;
    line-height: 60px;
    letter-spacing: -0.03em;
    text-align: left;
    color: white;
  }

  .login-modal-inner {
    width: 100%;
    margin-top: 20px;
    background: #111823;
    padding: 24px 24px;
    border-radius: 20px;
    border: 1px solid white;
  }

  &.login-page-only {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px;
    box-sizing: border-box;
  }

  &.login-page-only .login-page-panel {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 100%;
    max-width: 554px;
    height: auto;
    min-height: 622px;
    margin: 0 auto;
  }

  .btn-svg {
    padding: 10px 7px;
    background: #fff;
  }

  .btn-svg img {
    height: 22px;
    width: 22px;
  }

  .btn-text {
    padding: 0px 7px;
    height: 44px !important;
    background: rgb(66, 133, 244);
    font-size: 11px;
  }

  .combine-button {
    border-radius: 10px;
    overflow: hidden;
    padding: 10px 0px;
    border: none;
    outline: none;
    background: none;
    color: white;
    margin-right: 0px;
    cursor: pointer;
  }

  .login-or {
    font-size: 20px;
  }

  @media only screen and (max-width: 770px) {
    .combine-button {
      margin-right: 0px;
    }
  }
`;

export { LandingPageStyle };
